module.exports = __webpack_public_path__ + "static/media/04country.1a2443c0.mp3";